import React, { useEffect, useState } from "react";
import { LeaveOpeningAPI } from "../../../../api/Payroll/Leaveopening";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../../Loader/Loader";
const LeaveApprovel = () => {
  const [monthInput, setMonthInput] = useState(() =>
    new Date().toISOString().slice(0, 7)
  );
  const statusOptions = [
    // { label: "All Status", value: "" },
    { label: "Pending", value: "Pending" },
    { label: "Approved", value: "Approved" },
    { label: "Rejected", value: "Rejected" },
  ];
  const [getPendingLeaves, setPendingLeaves] = useState([]);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("school_user"));
  const { user_detail } = user || {};
  const [filterMonth, setFilterMonth] = useState(monthInput);
  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);

  const getPendingLeave = async () => {
    setLoading(true);
    setPendingLeaves([]);
    let data = {
      school_id: user_detail?.fk_school_id,
      attendance_month: filterMonth,
      is_approved: selectedStatus.value,
    };

    try {
      const response = await LeaveOpeningAPI.get_pending_leave_applications(
        data
      );
      const res = response.data;
      if (res.status === 200) {
        setPendingLeaves(res.applications); // Assuming you want to set actual data
      } else {
        console.error("Error fetching pending leaves:", res.msg);
      }
    } catch (error) {
      console.error("Error fetching pending leaves:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log(getPendingLeaves);
  useEffect(() => {
    getPendingLeave();
  }, []);

  const handleApprove = async (leave) => {
    console.log("i called");
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to approve this leave.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      const dataToSend = {
        application_id: leave.id,
        school_id: user_detail?.fk_school_id,
        staff_id: leave.staff_id,
        is_approved: "Approved",
      };

      try {
        const response = await LeaveOpeningAPI.process_leave_application(
          dataToSend
        );
        const res = response.data;

        if (res.status === 200) {
          Swal.fire("Approved!", "The leave has been approved.", "success");
          getPendingLeave();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.msg || "Something went wrong.",
          });
        }
      } catch (error) {
        Swal.fire("Error", "Server error occurred.", "error");
        console.error(error);
      }
    }
  };

  const handleReject = async (leave) => {
    const result = await Swal.fire({
      title: "Reject Leave",
      input: "textarea",
      inputLabel: "Reason for Rejection",
      inputPlaceholder: "Enter reason...",
      inputAttributes: {
        "aria-label": "Reason for rejection",
      },
      showCancelButton: true,
      confirmButtonText: "Reject",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      preConfirm: (reason) => {
        if (!reason) {
          Swal.showValidationMessage("Rejection reason is required.");
        }
        return reason;
      },
    });

    if (result.isConfirmed) {
      const reason = result.value;

      const dataToSend = {
        application_id: leave.id,
        school_id: user_detail?.fk_school_id,
        staff_id: leave.staff_id,
        is_approved: "Rejected",
        rejection_reason: reason, // include reason if your API supports it
      };

      try {
        const response = await LeaveOpeningAPI.process_leave_application(
          dataToSend
        );

        const res = response.data;

        if (res.status === 200) {
          Swal.fire("Rejected!", "The leave has been rejected.", "success");
          getPendingLeave();
        } else {
          Swal.fire("Error", "Something went wrong.", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Server error occurred.", "error");
        console.error(error);
      }
    }
  };

  const [rejectionReason, setRejectionReason] = useState("");

  if (loading) return <Loader />;

  return (
    <div className="container">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">Leave Application</h5>
      </div>
      <div className="card">
        <div className="card-body">
          {/* Filters */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label">Filter by Month</label>
              <div className="d-flex gap-2">
                <input
                  type="month"
                  value={monthInput}
                  onChange={(e) => setMonthInput(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="col-md-4">
              <label className="form-label">Filter by Status</label>
              <Select
                options={statusOptions}
                value={selectedStatus}
                onChange={setSelectedStatus}
              />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-outline-secondary"
                onClick={() => getPendingLeave()}
              >
                View
              </button>
            </div>
          </div>
          <div className="table-responsive mt-2">
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Staff Name</th>
                  <th>Leave Type</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Day Type</th>
                  <th>Reason</th>
                  <th>Status</th>
                  {
                    // Show "Actions" header only if there's any Pending leave
                    getPendingLeaves?.some(
                      (leave) => leave.status === "Pending"
                    ) && <th>Actions</th>
                  }
                </tr>
              </thead>
              <tbody>
                {getPendingLeaves?.length > 0 ? (
                  getPendingLeaves.map((leave) => (
                    <tr key={leave.id}>
                      <td>{leave.staff_name}</td>
                      <td>{leave.leave_type}</td>
                      <td>{leave.from_date}</td>
                      <td>{leave.to_date}</td>
                      <td>{leave.half_full_day}</td>
                      <td>{leave.reason}</td>
                      <td>
                        <span className="badge bg-warning text-dark p-2">
                          {leave.status}
                        </span>
                      </td>
                      {
                        // Show action buttons only if status is "Pending"
                        leave.status === "Pending" && (
                          <td>
                            <button
                              className="btn btn-success btn-sm mx-2"
                              onClick={() => handleApprove(leave)}
                            >
                              <i className="bi bi-check-circle me-1"></i>{" "}
                              Approve
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleReject(leave)}
                            >
                              <i className="bi bi-x-circle me-1"></i> Reject
                            </button>
                          </td>
                        )
                      }
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">No leave applications found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveApprovel;
